import { render, staticRenderFns } from "./ChartingWorkspaceWorkspacesDialog.vue?vue&type=template&id=3c837cce&scoped=true&"
import script from "./ChartingWorkspaceWorkspacesDialog.vue?vue&type=script&lang=js&"
export * from "./ChartingWorkspaceWorkspacesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChartingWorkspaceWorkspacesDialog.vue?vue&type=style&index=0&id=3c837cce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c837cce",
  null
  
)

export default component.exports